module.exports = __webpack_public_path__ + "static/img/black-logo1.6162543.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo/black-logo1.png
// module id = d/vU
// module chunks = 0